
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent9 as ObiWindApparent9Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-9.js';
 
 
 

 
 export const ObiWindApparent9 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-9',
   elementClass: ObiWindApparent9Element,
   events: {
     
   }
  });
 
 